import { __assign } from "tslib";
import { createHttpTestKit } from '../http/test-kit';
import { createFakePostResponder, createFakeGetResponder, createFakePutResponder, isWildcard } from '../test-utils';
import { autoEnrollmentUrl, createKbApi } from './';
import { createFakeDeleteResponder } from '../test-utils';
export var createKbApiTestKit = function () {
    var fakeHttp = createHttpTestKit();
    var api = createKbApi('', fakeHttp);
    // @ts-ignore - Ignore the error here, or handle wildcard ('*') param
    var testKit = {
        whenGetAdminTree: function (dto) {
            return createFakeGetResponder(fakeHttp, "/categories/admin?locale=".concat(isWildcard(dto) ? 'en' : dto.locale).concat(isWildcard(dto) ? '' : "".concat(!!dto.brandId ? "&brandId=".concat(dto.brandId) : '')));
        },
        whenGetTree: function (dto) {
            return createFakeGetResponder(fakeHttp, "/categories?locale=".concat(dto.locale).concat(!isWildcard(dto) && dto.brandId ? "&brandId=".concat(dto.brandId) : ''));
        },
        whenAddArticle: createFakePostResponder(fakeHttp, '/articles'),
        whenAddArticleAlternativeContent: createFakePostResponder(fakeHttp, '/articles/alternativeContent'),
        whenEndArticleAbTest: createFakePostResponder(fakeHttp, '/articles/alternativeContent/end'),
        whenAddCategory: function (dto, fail) {
            return createFakePostResponder(fakeHttp, '/categories', fail)(dto);
        },
        whenAddSubcategory: function (dto, fail) {
            var parentId = isWildcard(dto) ? 'some-id' : dto.parentId;
            return createFakePostResponder(fakeHttp, '/categories/' + parentId, fail)(__assign(__assign({}, (isWildcard(dto) ? {} : dto)), { parentId: undefined }));
        },
        whenUpdateCategory: function (dto) {
            // tslint:disable-next-line:max-line-length
            var id = isWildcard(dto) ? 'some-id' : dto.id;
            return createFakePutResponder(fakeHttp, '/categories/' + id)(__assign(__assign({}, (isWildcard(dto) ? {} : dto)), { id: undefined }));
        },
        whenDeleteCategory: function (dto) {
            return createFakeDeleteResponder(fakeHttp, "/categories/".concat(isWildcard(dto) ? 'some-id' : "".concat(dto.id).concat((dto.brandId ? "?brandId=".concat(dto.brandId) : ''))));
        },
        whenDeleteArticle: function (dto) {
            var id = isWildcard(dto) ? 'some-id' : dto.id;
            var locale = isWildcard(dto) ? 'en' : dto.locale;
            return createFakeDeleteResponder(fakeHttp, "/articles/".concat(id, "?locale=").concat(locale));
        },
        whenPublishArticle: function (dto) {
            var id = isWildcard(dto) ? 'some-id' : dto.id;
            // tslint:disable-next-line:max-line-length
            return createFakePostResponder(fakeHttp, "/articles/".concat(id, "/publish"))(__assign(__assign({}, (isWildcard(dto) ? {} : dto)), { id: undefined }));
        },
        whenUnpublishArticle: function (dto) {
            var id = isWildcard(dto) ? 'some-id' : dto.id;
            // tslint:disable-next-line:max-line-length
            return createFakePostResponder(fakeHttp, "/articles/".concat(id, "/unpublish"))(__assign(__assign({}, (isWildcard(dto) ? {} : dto)), { id: undefined }));
        },
        whenMoveArticle: function (dto) {
            var id = isWildcard(dto) ? 'some-id' : dto.id;
            return createFakePostResponder(fakeHttp, "/articles/".concat(id, "/move"))(dto);
        },
        whenMoveSubcategory: function (dto) {
            var id = isWildcard(dto) ? 'some-id' : dto.id;
            // tslint:disable-next-line:max-line-length
            return createFakePutResponder(fakeHttp, "/categories/".concat(id, "/parent"))(__assign(__assign({}, (isWildcard(dto) ? {} : dto)), { id: undefined }));
        },
        whenSortCategories: function (dto) {
            // tslint:disable-next-line:max-line-length
            return createFakePostResponder(fakeHttp, "/categories/sort")(dto);
        },
        whenAddArticleTranslations: function (dto) {
            var id = isWildcard(dto) ? 'some-id' : dto.id;
            return createFakePostResponder(fakeHttp, "/articles/".concat(id, "/translations"))(__assign(__assign({}, (isWildcard(dto) ? {} : dto)), { id: undefined }));
        },
        whenUpdateArticleLabels: function (dto) {
            var id = isWildcard(dto) ? 'some-id' : dto.id;
            return createFakePutResponder(fakeHttp, "/articles/".concat(id, "/labels"))(__assign(__assign({}, (isWildcard(dto) ? {} : dto)), { id: undefined }));
        },
        whenDuplicateArticle: function (dto) {
            return createFakePostResponder(fakeHttp, '/articles/duplicate')(__assign({}, (isWildcard(dto) ? {} : dto)));
        },
        whenGetArticleStatistics: function (dto) {
            var id = isWildcard(dto) ? 'some-id' : dto.id;
            var locale = isWildcard(dto) ? 'en' : dto.locale;
            return createFakeGetResponder(fakeHttp, "/_serverless/knowledge-base/articles/".concat(id, "/statistics?locale=").concat(locale));
        },
        whenCreatePopulation: function (dto) {
            return createFakePostResponder(fakeHttp, "".concat(autoEnrollmentUrl, "/population"))(dto);
        },
        whenGetPopulationStatus: function (dto) {
            var populationId = isWildcard(dto) ? 'some-id' : dto.populationId;
            return createFakeGetResponder(fakeHttp, "".concat(autoEnrollmentUrl, "/population/").concat(populationId, "/status"));
        },
        whenGetPopulationStatusBulk: function (dto) {
            return createFakePostResponder(fakeHttp, "".concat(autoEnrollmentUrl, "/population/status"))(dto);
        },
        whenJoinPopulation: function (dto) {
            var populationId = isWildcard(dto) ? 'some-id' : dto.populationId;
            return createFakePostResponder(fakeHttp, "".concat(autoEnrollmentUrl, "/element/").concat(populationId))({});
        },
        whenLeavePopulation: function (dto) {
            var populationId = isWildcard(dto) ? 'some-id' : dto.populationId;
            return createFakeDeleteResponder(fakeHttp, "".concat(autoEnrollmentUrl, "/element/").concat(populationId));
        },
        whenOptInFeature: function (dto) {
            var id = isWildcard(dto) ? 'some-id' : dto.id;
            return createFakePostResponder(fakeHttp, "/articles/".concat(id, "/enroll"))(dto);
        },
        whenOptOutFeature: function (dto) {
            var id = isWildcard(dto) ? 'some-id' : dto.id;
            var locale = isWildcard(dto) ? 'en' : dto.locale;
            return createFakeDeleteResponder(fakeHttp, "/articles/".concat(id, "/enroll?locale=").concat(locale));
        },
        whenSearchSpecs: function (dto) {
            return createFakePostResponder(fakeHttp, "".concat(autoEnrollmentUrl, "/petri/specs/search"))(dto);
        },
        whenCreateSpec: function (dto) {
            return createFakePostResponder(fakeHttp, "".concat(autoEnrollmentUrl, "/petri/specs"))(dto);
        },
        whenCreateExperiment: function (dto) {
            return createFakePostResponder(fakeHttp, "".concat(autoEnrollmentUrl, "/petri/experiments"))(dto);
        },
        whenTerminateExperiment: function (dto) {
            var experimentId = isWildcard(dto) ? 'some-id' : dto.experimentId;
            return createFakeDeleteResponder(fakeHttp, "".concat(autoEnrollmentUrl, "/petri/experiments/").concat(experimentId));
        }
    };
    return __assign(__assign({}, api), testKit);
};
//# sourceMappingURL=testkit.js.map